<script>
	import SceneController from "./pages/SceneController.svelte";
</script>

<SceneController />